import React, { FC, useEffect, useState } from "react";
import { useDispatch }                    from "react-redux";
import { Icon, Label, Loader }            from "semantic-ui-react";
import GetCustomerRecordCount             from "../../../application/usecase/record/customer/GetCustomerRecordCount";
import Customer                           from "../../../domain/customer/Customer";

interface Props {
  customer: Customer;
}

const CustomerRecordCountLabel: FC<Props> = (props: Props) => {
  const {customer} = props;
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const getCustomerRecordCount: GetCustomerRecordCount = new GetCustomerRecordCount(useDispatch());

  useEffect(() => {
    getCustomerRecordCount.execute(customer.id, setCount, setLoading);
  }, [customer]);

  return (
    <>
      <Label>
        <Icon name="file alternate"/>
        {
          loading
            ?
            <>
              <Loader active inline size="mini"/>
            </>
            :
            count
        }
        <Label.Detail>記録件数</Label.Detail>
      </Label>
    </>
  );
};

export default CustomerRecordCountLabel;
